import React, { useState } from "react";
import { 
  FaUser, FaBook, FaSchool, FaCalendarAlt, 
  FaMosque, FaPrayingHands, FaQuestionCircle, 
  FaStar, FaLibrary, FaChild, FaBlog, FaLandmark,
  FaBookReader,
  FaBookOpen,
  FaUsers
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./Sidebar.css";
import MenuModal from "./MenuModal";

const routeMap = {
  users: "(Admins)/screens/users/adminUserList",
  pandits: "(Admins)/screens/pandits/adminPanditList",
  departments: "(Admins)/screens/departments/adminDepartmentList",
  events: "(Admins)/screens/events/adminEventList",
  quizzes: "(Admins)/screens/quizzes/adminQuizList",
  prayers: "(Admins)/screens/prayers/adminPrayerList",
  specialdays: "(Admins)/screens/specialdays/adminSpecialDaysList",
  mandirs: "(Admins)/screens/mandirs/adminMandirList",
  hindilearning: "(Admins)/screens/hindilearning/adminHindiLearningList",
  kinderhuis: "(Admins)/screens/kinderhuis/adminKinderhuisList",
  ebibliotheek: "(Admins)/screens/ebibliotheek/adminEBibliotheekList",
  dharmalearning: "(Admins)/screens/dharmalearning/adminDharmaLeerList",
  schools: "(Admins)/screens/schools/adminSchoolList",
  hoofdbestuur: "(Admins)/screens/hoofdbestuur/adminHoofdbestuurList",
  blogs: "(Admins)/screens/blogs/adminBlogList",
};

const icons = {
  users: <FaUser />,
  pandits: <FaUsers />,
  departments: <FaBook />,
  events: <FaCalendarAlt />,
  quizzes: <FaQuestionCircle />,
  prayers: <FaPrayingHands />,
  specialdays: <FaStar />,
  mandirs: <FaMosque />,
  hindilearning: <FaBook />,
  kinderhuis: <FaChild />,
  ebibliotheek: <FaBookReader />,
  dharmalearning: <FaBookOpen />,
  schools: <FaSchool />,
  hoofdbestuur: <FaLandmark />,
  blogs: <FaBlog />,
};

const labels = {
  users: "Users",
  pandits: "Pandits",
  departments: "Departments",
  events: "Events",
  quizzes: "Quizzes",
  prayers: "Prayers",
  specialdays: "Special Days",
  mandirs: "Mandirs",
  hindilearning: "Hindi Learning",
  kinderhuis: "Kinderhuis",
  ebibliotheek: "E-Bibliotheek",
  dharmalearning: "Dharma Learning",
  schools: "Schools",
  hoofdbestuur: "Hoofdbestuur",
  blogs: "Blogs",
};

export default function Sidebar() {
  const [isModalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <aside className="sidebar">
        <ul>
          {Object.keys(routeMap).map((key) => (
            <li key={key} title={labels[key]} onClick={() => navigate(`/${routeMap[key]}`)}>
              {icons[key]}
            </li>
          ))}
        </ul>
        <button className="expand-btn" onClick={() => setModalOpen(true)}>
          Menu
        </button>
      </aside>

      {isModalOpen && (
        <MenuModal
          routeMap={routeMap}
          icons={icons}
          labels={labels}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  );
}
